/**
 * Every sentence the Noor app SHELL shows -- and there is ONE. The screens under the shell carry their own copy
 * (`const/partners-*-copy.ts`), and the hosted account carries the profile surface's; nothing here restates a word of
 * either.
 *
 * ONE SENTENCE, THREE PLACES (2026-09-17). The shell used to carry four: a gate body, a modal subtitle, a document
 * description and a tagline, each wording the same purpose differently, with the act spelled "Sign in" in the prose
 * and "Log in" on the buttons. What Noor is for is said once, in `purpose`, and the gate, the sign-in modal and the
 * `<meta name="description">` all read it; the act is the fleet's own verb (`logInTo`, over `LABEL_LOG_IN`), so the
 * heading and the button it sits above cannot disagree.
 */

import { logInTo } from './label-values.ts';
import { NOOR_PRODUCT_NAME } from './noor-identity.ts';

export const NOOR_APP_COPY = {
	/** What Noor is for: the two blocks of the home, by the words they are headed with (operator, 2026-09-17: Services,
	 *  Engagements), so the first sentence a partner reads and the page they then use are one vocabulary -- the sibling
	 *  suite derives that from the blocks' own headings. No verb: Noor speaks as a Sage -- it states what is here, it
	 *  does not instruct. Short enough to sit on ONE line under the sign-in modal's title; a longer wording wrapped there
	 *  and left two words alone on the second line. */
	purpose: 'Your services and engagements.',
	/** The gate's heading: the act, in the verb the button under it carries. */
	signedOutTitle: logInTo(NOOR_PRODUCT_NAME),
} as const;
